import React from 'react';

export const CartItemsHeader = () => {
    return (
        <li className="list-group-item">
            <div className="row d-flex d-lg-none">
                <div className="col">
                    <h3 className="text-center h4 lg-0">Cart items</h3>
                </div>
            </div>
            <div className="row d-none d-lg-flex">
                <div className="icon-header col-lg-1 col-xl-1" />
                <div className="name-header col-lg-3 col-xl-4">
                    <p className="my-1">
                        <strong>Name</strong>
                    </p>
                </div>
                <div className="price-header col-lg-2 col-xl-2">
                    <p className="text-end my-1">
                        <strong>Price</strong>
                    </p>
                </div>
                <div className="quantity-header col-lg-3 col-xl-3">
                    <p className="text-end me-4 my-1">
                        <strong className="me-1">Quantity</strong>
                    </p>
                </div>
                <div className="total-header col-lg-3 col-xl-2">
                    <p className="text-end my-1">
                        <strong>Total</strong>
                    </p>
                </div>
            </div>
        </li>
    );
};
